export default {
  chartTitle: 'KHỚP LỆNH THEO THỜI GIAN VÀ BƯỚC GIÁ',
  busdChartTitle: 'Biểu đồ Mua/Bán Chủ Động',

  chartLegend: {
    buyUp: 'Mua chủ động (BU)',
    sellDown: 'Bán chủ động (SD)',
    unidentified: 'Không xác định',
    price: 'Giá',
  },

  listTitleTable: {
    time: 'THỜI GIAN',
    type: 'KIỂU',
    lastPrice: 'GIÁ KHỚP',
    change: 'THAY ĐỔI',
    percent1Dchange: '% THAY ĐỔI',
    lastVolume: 'KL KHỚP',
    totalVolume: 'TỔNG KL KHỚP',
  },
  table: 'Bảng',
  chart: 'Biểu đồ',
  tab: {
    today: 'Hôm nay',
    oneWeek: '5 Ngày',
    oneMonth: '20 Ngày',
    // oneQuarter: '60 Ngày',
  },
  tooltip: {
    price: 'Giá: %{value}',
    volume: 'KL: %{value}',
  },
  volume: 'Khối lượng',
};
